import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import {
  addVehicleToBulkActionsList,
  assignVehicleTransport,
  removeVehicleFromBulkActionsList,
} from '../../../Vehicles/actions';
import { refreshBoards } from '../../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { HBox, VBox } from '../../../../components/Box';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import { selectCompanyProperty } from '../../../Companies/selectors';
import { selectAddress } from '../../../Address/selectors';
import { REQUEST_COMPANIES_PROPERTY } from '../../../Companies/constants';
import { REQUEST_ADDRESSES_BY_IDS } from '../../../Address/constants';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { selectVehicleBulkActionsList } from '../../../Vehicles/selectors';
import { Checkbox } from '../../../../components/Checkbox';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};
const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }
  p {
    margin: 0;
  }

  .col-regplate-vin {
    max-width: 200px;
  }

  .col-model-info {
    min-width: 150px;
    max-width: 150px;
  }

  .col-address-from {
    min-width: 250px;
    max-width: 250px;
  }

  .col-address-to {
    min-width: 200px;
    max-width: 200px;
  }
  .regplate {
    font-size: 14px;
  }
  font-size: 12px;
`;

const STATE = {
  approve: false,
  selected: null,
  loading: false,
};

export const TransportAssignable = {
  NONE: '0',
  Extern_transport: '1',
  Alwin_ter_Schure: '2',
  John_van_de_Berg: '3',
  Matthijs_Nijkamp: '4',
  Dirk: '5',
  Harry_Nijboer: '6',
  Overig_intern: '7',
  Wachten_op_transport: '8',
};

export const TransportAssignableOptions = _.map(TransportAssignable, (value, name) => ({ label: name, value: value }));

/* eslint-disable react/prefer-stateless-function */
class IDWE_transport_in_DLA24Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
    this.state = {
      selected: null,
    };
  }

  setStateFn = newState => () => {
    this.setState(newState);
  };
  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  get action() {
    return this.props.action;
  }

  get bulkActionsList() {
    let list = [];
    if (this.props.bulkActionsList?.length) {
      list = this.props.bulkActionsList;
    }
    return list;
  }

  isSelectedVehicle() {
    return this.bulkActionsList?.filter(item => item?.id == this.vehicle?.id)?.length == 1;
  }

  onSelectVehicle(e, vehicle) {
    e.stopPropagation();
    if (this.isSelectedVehicle(vehicle?.id)) {
      return this.props.removeVehicleFromBulkActionsList(vehicle?.id);
    }

    return this.props.addVehicleToBulkActionsList(vehicle, this.action.functionName);
  }

  renderApprove() {
    const vehicle = this.vehicle;
    if (this.props.work) return;

    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={this.lbl('kanbanboards.cell.Transport_1_nl_in.modal.incoming_transport_plan')}
      >
        <HBox flexWrap center>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            <row>
              <VBox vCenter>
                <VBox className="regplate col-regplate-vin">
                  <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
                  <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
                </VBox>
                <VBox className="col-model-info">
                  <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
                  <p>{vehicle.model_name}</p>
                </VBox>
                <VBox className="address col-address-from">
                  <CompanyLabelById
                    fetchName
                    transportCard
                    transport_to={vehicle?.transport_incoming_from_company_name}
                    company_id={vehicle?.transport_incoming_from_company_id}
                  />
                  <AddressFields inlineshort addressId={vehicle.transport_from_address_id} />
                  <div className="mb-1">
                    <CompanyLabelById fetchPhone company_id={vehicle.transport_incoming_from_company_id} />
                  </div>
                </VBox>
                <VBox className="address col-address-to"></VBox>
                <VehicleStatusLabel>in</VehicleStatusLabel>
              </VBox>
              {this.state.selected === '1' && (
                <div>
                  <VehiclePropertyEditableInput propertyName="transporter_extern" vehicle_id={this.vehicle.id} />
                </div>
              )}
            </row>
          </div>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            <br />

            {TransportAssignableOptions.map(a => (
              <Button
                primary={a.value === this.state.selected}
                key={a.label}
                onClick={this.setStateFn({ selected: a.value })}
              >
                {a.label.replace(/_/g, ' ')}
              </Button>
            ))}
          </div>
        </HBox>
        <ModalControls>
          {this.props.work || this.state.loading ? (
            <Loader small />
          ) : (
            <>
              <Button
                primary
                onClick={() => {
                  this.setState({ loading: true });
                  this.props.assign(this.state.selected, this.reset.bind(this));
                }}
              >
                {this.lbl('save')}
              </Button>
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter>
            <Checkbox checked={this.isSelectedVehicle()} onChange={e => this.onSelectVehicle(e, vehicle)} />
            <VBox left className="regplate col-regplate-vin">
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
              <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
            </VBox>
            <VBox left className="col-model-info">
              <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
              <p>{vehicle.model_name}</p>
            </VBox>
            <VBox left className="address col-address-from">
              {this.props.companyName && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_incoming_from_company_name}
                  company_id={vehicle?.transport_incoming_from_company_id}
                />
              )}
              {this.props.address && <AddressFields inlineshort addressId={vehicle.transport_from_address_id} />}
              <div className="mb-1">
                <CompanyLabelById fetchPhone company_id={vehicle.transport_incoming_from_company_id} />
              </div>
            </VBox>
            {/* <VBox left className="address col-address-to">
              <CompanyLabelById
                fetchName
                transportCard
                transport_to={vehicle?.transport_incoming_to_company_name}
                company_id={vehicle.buying_company}
              />
              <AddressFields inlineshort addressId={vehicle.transport_to_address_id} />
            </VBox> */}
            <VehicleStatusLabel>in</VehicleStatusLabel>
            <Label count={vehicle?.transportinkomend} ranges={ranges}>
              {vehicle?.transportinkomend || '0'}
            </Label>
          </HBox>
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

IDWE_transport_in_DLA24Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    companyName: selectCompanyProperty(ownProps.cell.vehicle.transport_incoming_from_company_id, 'name'),
    address: selectAddress(ownProps.cell.vehicle.transport_from_address_id),
    bulkActionsList: selectVehicleBulkActionsList(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    //
    assign(id, callback) {
      dispatch(
        assignVehicleTransport(ownProps.cell.vehicle.id, `${id}`, false, false, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    addVehicleToBulkActionsList(vehicle, kanbanTaskName) {
      dispatch(addVehicleToBulkActionsList(vehicle, [], kanbanTaskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDWE_transport_in_DLA24 = compose(withConnect, withRouter)(IDWE_transport_in_DLA24Comp);
